// extracted by mini-css-extract-plugin
module.exports = {"container":"ChartBar_container__3LcLs","periods":"ChartBar_periods__3HYfk"};